var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"DeepPink"}},[_vm._v("This is a global registered component")])}
var staticRenderFns = []

export { render, staticRenderFns }